import { SxProps, Tooltip, Typography, useTheme } from '@mui/material'
import { format } from 'date-fns'

import rem from '~/utils/ui'

type TProps = {
  activityDate: string
  sx?: SxProps
}

function Timestamp({ activityDate, sx = {} }: TProps) {
  const theme = useTheme()

  if (!activityDate || !new Date(activityDate).getTime()) {
    return null
  }

  return (
    <Tooltip
      title={format(new Date(activityDate), 'EEEE, MMMM d, h:mm a')}
      placement="top"
    >
      <Typography
        variant="body2"
        sx={{
          position: 'absolute',
          bottom: rem(4),
          right: rem(12),
          color: theme.palette.tertiary4,
          fontSize: rem(12),
          lineHeight: rem(24),
          ...sx,
        }}
      >
        {format(activityDate, 'h:mm a')}
      </Typography>
    </Tooltip>
  )
}

export default Timestamp
